export function scrollIdIntoView(id: string) {
  document.querySelector(`#${id}`)?.scrollIntoView({
    behavior: 'smooth',
  });
}
